<template>
  <div class="account-summary">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">
          {{$t('summary.account_summary')}} {{summary.login}}
          <a
            class="pull-right btn-settings"
            href="/client/profile"
          >
            <i class="fa fa-cog"></i>
          </a>
        </h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-15 col-md-6">
        <summary-box
          title="Balance"
          v-bind:value="summary.balance | formatNumber"
          symbol
          v-bind:isLoading="loader.summary"
        ></summary-box>
      </div>
      <div class="col-lg-15 col-md-4">
        <summary-box
          title="Credit"
          v-bind:value="summary.credit"
          symbol
          v-bind:isLoading="loader.summary"
        ></summary-box>
      </div>
      <div class="col-lg-15 col-md-6">
        <summary-box
          title="Equity"
          v-bind:value="summary.equity | formatNumber"
          symbol
          v-bind:isLoading="loader.summary"
        ></summary-box>
      </div>
      <div class="col-lg-15 col-md-4">
        <summary-box
          title="Margin"
          v-bind:value="summary.margin | formatNumber"
          symbol
          v-bind:isLoading="loader.summary"
        ></summary-box>
      </div>
      <div class="col-lg-15 col-md-4">
        <div class="panel panel-simple panel-simple-color">
          <summary-box
            title="Margin Level"
            v-bind:value="summary.marginLevel | formatNumber"
            symbol="%"
            v-bind:isLoading="loader.summary"
          ></summary-box>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import EventBus from "../event-bus";
import Vue from "vue";
import SummaryBox from "../components/AccountSummaryBox";
import { getSummary } from "../services/MT4Service";
import AccountService from "@/services/AccountService";

let accountService = new AccountService();

Vue.component("summary-box", SummaryBox);

export default {
  name: "account-summary",
  data: function() {
    return {
      summary: {},
      loader: {
        summary: true
      }
    };
  },
  methods: {
    populateComponent(account){
      let t = this;
      t.loader.summary = true;
      if (account == null){
        accountService.getDefaultMt4Account()
        .then(r => {
          return r;
        })
        .then(r => {
          getSummary(r.data).then(function(r) {
            t.summary = r.data;
            t.loader.summary = false;
          });
        });
      }else{
        t.summary.login = account.login;
          getSummary(account).then(function(r) {
            t.summary = r.data;
            t.loader.summary = false;
          });
      }
    }
  },
  created() {
    EventBus.$on('onUpdateDefaultMt4Account', (d)=>{
      this.populateComponent(d);
    });
    this.populateComponent(null);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/AccountSummary.vue